import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetSellerUseCase extends UseCase {
  constructor({getSellerRequestMapper, service}) {
    super()

    this._getSellerRequestMapper = getSellerRequestMapper
    this._getSellerService = service
  }

  @inlineError
  async execute({contractId, userId} = {}) {
    const sellerRequestVO = this._getSellerRequestMapper.map({
      contractId,
      userId
    })

    const [error, sellerEntity] = await this._getSellerService.execute({
      sellerRequestVO
    })

    if (error) return Promise.reject(error)

    return sellerEntity ? sellerEntity.toJSON() : null
  }
}
